export default function findValFromObj(object: any, key?: string) {
  if (!object || typeof object !== 'object') return '';
  if (!key) return '';
  let value;
  Object.keys(object).some((k) => {
    if (k === key) {
      value = object[k];
      return true;
    }
    if (object[k] && typeof object[k] === 'object') {
      value = findValFromObj(object[k], key);
      return value !== undefined;
    }
    return false;
  });
  return value;
}


type Transaction = {
  glAccountName: string;
  glCode: string;
  runningBalance: number;
};

type InputRecord = {
  [parentKey: string]: {
    [childKey: string]: Transaction[];
  };
};

export type OutputStructure = {
  label: string;
  runningBalance: number;
  child: {
    label: string;
    runningBalance: number;
    gls: {
      glAccountName: string;
      glCode: string | number;
      runningBalance: number;
    }[];
  }[];
}[];

export function TransformRecords(records: InputRecord): OutputStructure {
  const result: OutputStructure = [];

  for (const parentKey in records) {
    let runningBalance = 0;
    const childArray = [];

    const childGroups = records[parentKey];
    for (const childKey in childGroups) {
      const transactions = childGroups[childKey];
      const totalRunningBalance = transactions.reduce(
        (sum, txn) => sum + txn.runningBalance,
        0
      );

      runningBalance += totalRunningBalance;

      childArray.push({
        label: childKey.replaceAll('_', ' '),
        runningBalance: totalRunningBalance,
        gls: transactions.map((txn) => ({
          glAccountName: txn.glAccountName,
          glCode: txn.glCode,
          runningBalance: txn.runningBalance,
        })),
      });
    }

    result.push({
      label: parentKey.replaceAll('_', ' '),
      runningBalance,
      child: childArray,
    });
  }

  return result;
}

